import * as React from "react"
export const Svg_073 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={59}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        fill="url(#b)"
        d="M5.755 44.447 8.2 42.003l8.787 8.787-2.444 2.445-8.787-8.788Z"
      />
      <path
        fill="url(#c)"
        d="M1.82 48.391A6.174 6.174 0 0 0 0 52.786c0 1.66.646 3.22 1.82 4.394A6.174 6.174 0 0 0 6.214 59c1.66 0 3.22-.646 4.395-1.82l1.496-1.496-8.789-8.789-1.496 1.496Z"
      />
      <path
        fill="url(#d)"
        d="m15.402 34.81-4.752 4.752 8.788 8.788 4.752-4.752a25.48 25.48 0 0 1-4.934-3.853 25.465 25.465 0 0 1-3.854-4.935Z"
      />
      <path
        fill="url(#e)"
        d="M37.15 43.7C49.198 43.7 59 33.898 59 21.85 59 9.802 49.198 0 37.15 0 25.102 0 15.3 9.802 15.3 21.85c0 12.048 9.802 21.85 21.85 21.85ZM20.093 21.85c0-9.405 7.652-17.057 17.057-17.057 9.406 0 17.057 7.651 17.057 17.057 0 9.405-7.651 17.057-17.057 17.057-9.405 0-17.057-7.652-17.057-17.057Z"
      />
      <path
        fill="url(#f)"
        d="M50.75 21.85c0-7.499-6.101-13.6-13.6-13.6s-13.6 6.1-13.6 13.6c0 7.499 6.101 13.6 13.6 13.6s13.6-6.101 13.6-13.6Zm-20.728 4.683 4.684-4.683-4.684-4.684 2.445-2.444 4.683 4.683 4.684-4.683 2.444 2.444-4.683 4.684 4.683 4.683-2.444 2.445-4.684-4.684-4.683 4.684-2.445-2.445Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={7.639}
        x2={12.705}
        y1={45.2}
        y2={43.279}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={2.799}
        x2={8.549}
        y1={48.711}
        y2={58.017}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={13.781}
        x2={20.213}
        y1={36.841}
        y2={47.25}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={25.406}
        x2={46.163}
        y1={6.555}
        y2={40.149}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={29.84}
        x2={42.76}
        y1={12.33}
        y2={33.24}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h59v59H0z" />
      </clipPath>
    </defs>
  </svg>
)